import { FirestoreDataConverter } from "@angular/fire/firestore";

/**
 * SupplierInvitation class
 */
export class SupplierInvitation {
  id: string;
  toOrganizationId: string;
  toEmail: string;
  fromOrganizationId: string;
  fromUserId: string;

  constructor(invitation?: Partial<SupplierInvitation>) {
    this.id = invitation?.id ?? '';
    this.toOrganizationId = invitation?.toOrganizationId ?? '';
    this.toEmail = invitation?.toEmail ?? '';
    this.fromOrganizationId = invitation?.fromOrganizationId ?? '';
    this.fromUserId = invitation?.fromUserId ?? '';
  }

  /**
   * Converter used to convert an organization from firebase
   */
  static converter: FirestoreDataConverter<SupplierInvitation> = {
    toFirestore: (supplierInvitation: SupplierInvitation) => ({
      id: supplierInvitation.id ,
      toOrganizationId: supplierInvitation.toOrganizationId,
      toEmail: supplierInvitation.toEmail,
      fromOrganizationId: supplierInvitation.fromOrganizationId,
      fromUserId: supplierInvitation.fromUserId,
    }),
    fromFirestore: (snapshot, options) => {
      const data = snapshot.data(options);
      return new SupplierInvitation({
        ...data,
        id: snapshot.id,
      });
    }
  }
}
